import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from '../data/mock';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    // Set direction based on language
    const newDirection = language === 'ar' ? 'rtl' : 'ltr';
    setDirection(newDirection);
    document.documentElement.dir = newDirection;
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  const t = (path) => {
    const keys = path.split('.');
    let value = translations[language];
    
    for (const key of keys) {
      if (value && value[key]) {
        value = value[key];
      } else {
        // Fallback to English if translation not found
        value = translations.en;
        for (const k of keys) {
          if (value && value[k]) {
            value = value[k];
          }
        }
        break;
      }
    }
    
    return value || path;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, direction }}>
      {children}
    </LanguageContext.Provider>
  );
};
